
import Vue from "vue";
import {
  userMapActions,
  userMapMutations,
  userMapGetters,
  userMapState
} from "@/store/modules/user";
import { getMinutes } from "date-fns";

export default Vue.extend({
  props: {
    phone: {
      type: String,
      default: ""
    },
    phoneType: {
      type: String,
      default: ""
    },
    isSettings: {
      type: Boolean,
      required: true,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      editingNumberVisible: false,
      verificationCode: "",
      error: "",
      setVerified: true,
      value: "",
      editPhone: false,
      codeSent: false
    };
  },
  methods: {
    ...userMapActions(["requestVerifyPhoneCode", "verifyPhone", "getUser"]),
    ...userMapMutations(["SET_EDIT_USER"]),
    async sendVerificationCode(phone: string, type: string): Promise<void> {
      this.$modal.hide("sendVerificationCodeModal");
      this.codeSent = true;
      try {
        let phoneNumber = {};
        if (type === "primary") {
          phoneNumber = {
            phone: {
              primary: phone
            }
          };
        } else if (type === "secondary") {
          phoneNumber = {
            phone: {
              secondary: phone
            }
          };
        }
        this.$modal.show("verifyPhoneNumberModal");
        await this.requestVerifyPhoneCode(phoneNumber);
        if (this.getEditingUser) {
          await this.getUser(this.getEditingUser._id);
        }
      } catch (e) {
        this.error = e.message;
        this.$bugSnagClient.notify(e);
      }
    },
    async verifyCode(): Promise<void> {
      try {
        const code = {
          code: this.verificationCode,
          phoneType: this.phoneType
        };
        await this.verifyPhone(code);
        if (this.getEditingUser) {
          this.SET_EDIT_USER(this.getEditingUser._id);
        }
        this.$modal.hide("verifyPhoneNumberModal");
        this.$emit("setVerified", true);
        this.$emit("editPhone", false);
      } catch (e) {
        this.error = e.message;
        this.$bugSnagClient.notify(e);
      }
    },
    async enterCode(): Promise<void> {
      this.$modal.show("verifyPhoneNumberModal");
    },
    async openSendCode(): Promise<void> {
      this.$modal.show("sendVerificationCodeModal");
    }
  },
  computed: {
    ...userMapGetters(["getEditingUser", "getUserById"]),
    ...userMapState(["makingApiRequest"]),
    hasCode(): any {
      let value: boolean = false;
      if (!this.getEditingUser) return false;
      switch (this.phoneType) {
        case "primary":
          if (this.getEditingUser.hasPrimaryCode) {
            value = true;
          } else {
            value = false;
          }
          break;
        case "secondary":
          if (this.getEditingUser.hasSecondaryCode) {
            value = true;
          } else {
            value = false;
          }
          break;
      }
      return value;
    },
    resendCodeTime(): number | Date {
      let dt: any;
      if (!this.getEditingUser) return 0;
      switch (this.phoneType) {
        case "primary":
          if (!this.getEditingUser.phone.primaryVerified.resendCodeDate)
            return 0;
          dt =
            this.getEditingUser.phone.primaryVerified.resendCodeDate instanceof
            Date
              ? this.getEditingUser.phone.primaryVerified.resendCodeDate
              : new Date(
                  this.getEditingUser.phone.primaryVerified.resendCodeDate
                );
          break;
        case "secondary":
          if (!this.getEditingUser.phone.secondaryVerified.resendCodeDate)
            return 0;
          dt =
            this.getEditingUser.phone.secondaryVerified
              .resendCodeDate instanceof Date
              ? this.getEditingUser.phone.secondaryVerified.resendCodeDate
              : new Date(
                  this.getEditingUser.phone.secondaryVerified.resendCodeDate
                );
          break;
      }

      return getMinutes(dt) - getMinutes(new Date());
    }
  }
});
